import { fetchAllData, fetchMyProducts } from 'actions/Products'
import { fetchSubscription } from 'actions/Subscription'
import { Footer, HideScroll } from 'common'
import CartNotification from 'components/Cart/CartNotification'
import CustomerService from 'components/CustomerService'
import Errors from 'components/Errors'
import Header from 'components/Header/Header'
import CannotDeliverNotification from 'components/Notifications/CannotDeliverNotification'
import DeliveryDateChangedNotification from 'components/Notifications/DeliveryDateChangedNotification'
import DistributionErrorNotification from 'components/Notifications/DistributionErrorNotification'
import PaymentMethod3DSecureCallbackHandler from 'components/Payment/PaymentMethod3DSecureCallbackHandler'
import SubHeader from 'components/SubHeader'
import SubscriptionNotification from 'components/Subscription/SubscriptionNotification'
import BottomBar from 'components/UI/BottomBar'
import Loading from 'components/UI/LoadingScreen'
import PageTransition from 'components/UI/PageTransition'
import { ConnectedRouter } from 'connected-react-router'
import { fetchFocusPages } from 'focus'
import { MobileBottomNavigation } from 'navigation'
import { DesktopNotification, MobileBottomNotification } from 'notification'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Loadable from 'react-loadable'
import { connect } from 'react-redux'
import { Redirect, Route, Switch } from 'react-router'
import { FEATURES, isFeatureEnabled } from 'utilities/features'
import CookieConsent from '../../cookies/components/CookieConsent'
import { rerender } from '../../main.jsx'
import NavigationHeader from '../../navigation/components/MobileNavigation/NavigationHeader'
import classNames from 'classnames'
import { Helmet } from 'react-helmet'

const HomePage = Loadable({
    loader: () => import('../../home/pages/HomePage'),
    loading: Loading,
})

const Checkout = Loadable({
    loader: () => import('components/Checkout'),
    loading: Loading,
})

const AllProductsPage = Loadable({
    loader: () => import('product/pages/ProductListPage/AllProductsPage'),
    loading: Loading,
})

const DeliveryOptionsPage = Loadable({
    loader: () => import('components/Delivery/DeliveryOptionsPage'),
    loading: Loading,
})

const FocusPage = Loadable({
    loader: () => import('../../focus/pages/FocusPage'),
    loading: Loading,
})

const OrdersPage = Loadable({
    loader: () => import('components/Order/OrdersPage'),
    loading: Loading,
})

const OrderDetailsPage = Loadable({
    loader: () => import('components/Order/OrderDetailsPage'),
    loading: Loading,
})

const CartPage = Loadable({
    loader: () => import('components/Cart/CartPage'),
    loading: Loading,
})

const ProductModal = Loadable({
    loader: () => import('components/Product/ProductModal'),
    loading: Loading,
})

const MobileMyPage = Loadable({
    loader: () => import('components/MobileMyPage'),
    loading: Loading,
})

const NetworkErrorPage = Loadable({
    loader: () => import('components/NetworkErrorPage'),
    loading: Loading,
})

const NotificationsPage = Loadable({
    loader: () => import('components/Notifications/NotificationsPage'),
    loading: Loading,
})

const ProductPage = Loadable({
    loader: () => import('components/Product/ProductPage'),
    loading: Loading,
})

const SearchPage = Loadable({
    loader: () => import('components/Search/SearchPage'),
    loading: Loading,
})

const SupplierListPage = Loadable({
    loader: () => import('components/Supplier/SupplierListPage'),
    loading: Loading,
})

const SubscriptionPage = Loadable({
    loader: () => import('components/SubscriptionPage'),
    loading: Loading,
})

const PaymentMethodsPage = Loadable({
    loader: () => import('components/PaymentMethodsPage'),
    loading: Loading,
})

const SubscriptionPausePage = Loadable({
    loader: () => import('components/SubscriptionPausePage'),
    loading: Loading,
})

const SupplierPage = Loadable({
    loader: () => import('components/Supplier/SupplierPage'),
    loading: Loading,
})

const AboutUsPage = Loadable({
    loader: () => import('components/Article/AboutUsPage'),
    loading: Loading,
})

const ArticlePage = Loadable({
    loader: () => import('components/Article/ArticlePage'),
    loading: Loading,
})

const CampaignPage = Loadable({
    loader: () => import('campaign/pages/CampaignPage'),
    loading: Loading,
})

const AddressPage = Loadable({
    loader: () => import('components/Address/AddressPage'),
    loading: Loading,
})

const CheckDeliveryPage = Loadable({
    loader: () => import('components/CheckDeliveryPage'),
    loading: Loading,
})

const GiftPage = Loadable({
    loader: () => import('components/GiftPage'),
    loading: Loading,
})

const SubscriptionInfoPage = Loadable({
    loader: () => import('components/SubscriptionInfoPage'),
    loading: Loading,
})

const B2BPage = Loadable({
    loader: () => import('b2b/pages/B2B'),
    loading: Loading,
})

const ConceptPage = Loadable({
    loader: () => import('conceptPage/pages/ConceptPage'),
    loading: Loading,
})

class Router extends Component {
    constructor(props) {
        super(props)
        this.previousLocation = props.location
    }

    componentDidCatch(error, info) {
        console.log(error, info)
    }

    UNSAFE_componentWillUpdate(nextProps) {
        if (nextProps.history.action !== 'POP' && !this.isModal()) {
            this.previousLocation = this.props.location
        }
    }

    UNSAFE_componentWillMount() {
        this.fetchData()
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.region !== nextProps.region) {
            this.fetchData(nextProps.region)
        } else if (!this.props.isLoggedIn && nextProps.isLoggedIn && nextProps.region) {
            this.props.dispatch(fetchMyProducts())
        }
        if (!this.props.isLoggedIn && nextProps.isLoggedIn && nextProps.subscriptionEnabled) {
            this.props.dispatch(fetchSubscription())
        }
    }

    componentDidUpdate(prevProps) {
        const state = prevProps.location.state || {}
        if (state.reload) rerender()
    }

    componentWillUnmount() {
        clearTimeout(this.timer)
    }

    fetchData(region = this.props.region) {
        if (!region) return
        this.props.dispatch(fetchAllData(region))
        this.props.dispatch(fetchFocusPages(region))

        if (this.props.subscriptionEnabled) {
            this.props.dispatch(fetchSubscription())
        }

        // Refetch the data in one hour
        clearTimeout(this.timer)
        this.timer = setTimeout(this.fetchData.bind(this), 60 * 60 * 1000)
    }

    isModal() {
        const { location } = this.props
        return !!(location.state && location.state.modal)
    }

    render() {
        let {
            history,
            location,
            isMobile,
            isNetworkError,
            isCheckout,
            isCart,
            isDelivery,
            isProduct,
            isCategory,
            isUSPPage,
            isB2BPage,
            isApp,
            hasVisibleNotification,
        } = this.props
        const isModal = !isMobile && this.isModal()
        const showMobileBottomNavigation =
            isMobile && ((!isCart && !isDelivery && !isCheckout && !isB2BPage) || isUSPPage)
        const hideFooter =
            isApp ||
            isCart ||
            (isMobile && (isDelivery || isCategory || isProduct || isUSPPage || isCheckout))
        location = isModal ? this.previousLocation : location
        const isPageWithoutSubHeader =
            isNetworkError ||
            isB2BPage ||
            location.pathname === '/subscription' ||
            location.pathname === '/my-page/orders' ||
            location.pathname === '/gift-info' ||
            location.pathname === '/delivery-info' ||
            location.pathname === '/subscription-info' ||
            location.pathname === '/my-page/addresses' ||
            new RegExp(/^\/checkout/).test(location.pathname) ||
            new RegExp(/^\/cart/).test(location.pathname)
        const bottomSpaceClasses = classNames({
            'bottom-space': showMobileBottomNavigation || (isMobile && hasVisibleNotification),
            'bottom-space--double':
                showMobileBottomNavigation && isMobile && hasVisibleNotification,
        })

        return (
            <React.Fragment>
                <Helmet>
                    <title>Morgenlevering</title>
                    <meta property="og:title" content="Morgenlevering" />
                    <meta
                        property="og:image"
                        content="https://morgenlevering.no/static/fb-banner.jpg"
                    />
                    <meta property="og:url" content="https://morgenlevering.no" />
                </Helmet>

                <ConnectedRouter history={history}>
                    <div>
                        <PageTransition history={history} location={location} isMobile={isMobile}>
                            {!isB2BPage && <Header />}
                            {!isMobile && !isPageWithoutSubHeader && <SubHeader />}
                            {!isMobile && !isB2BPage && isPageWithoutSubHeader && (
                                <DesktopNotification />
                            )}
                            {isMobile && (
                                <HideScroll>
                                    <NavigationHeader showBackButton={location.pathname !== '/'} />
                                </HideScroll>
                            )}
                            <CookieConsent />
                            <Route path="/checkout" component={Errors} />
                            <div id="nav-root" />
                            <div className="main">
                                {isNetworkError ? (
                                    <NetworkErrorPage />
                                ) : (
                                    <Switch location={location}>
                                        <Route path="/checkout" component={Checkout} />
                                        <Route path="/delivery" component={DeliveryOptionsPage} />
                                        <Route
                                            path="/products/:category?/:subcategory?"
                                            component={AllProductsPage}
                                        />
                                        <Redirect
                                            from="/category/:category/:subcategory?"
                                            to="/products/:category/:subcategory?"
                                        />
                                        <Route path="/cart" component={CartPage} />
                                        <Route path="/my-page" exact component={MobileMyPage} />
                                        <Route path="/my-page/orders" component={OrdersPage} />
                                        <Route
                                            path="/my-page/payment-methods"
                                            component={PaymentMethodsPage}
                                        />
                                        <Route
                                            path="/my-page/order/:orderId"
                                            component={OrderDetailsPage}
                                        />
                                        <Route
                                            path="/my-page/notifications"
                                            component={NotificationsPage}
                                        />
                                        <Route path="/my-page/addresses" component={AddressPage} />
                                        <Route
                                            path="/supplier/:supplier"
                                            component={SupplierPage}
                                        />
                                        <Route path="/supplier" component={SupplierListPage} />
                                        <Route path="/subscription" component={SubscriptionPage} />
                                        <Route
                                            path="/subscriptionPause"
                                            component={SubscriptionPausePage}
                                        />
                                        <Route path="/product/:productId" component={ProductPage} />
                                        <Route path="/search/:query" component={SearchPage} />
                                        <Route
                                            path="/article/om-morgenlevering"
                                            component={AboutUsPage}
                                        />
                                        <Route path="/article/:slug" component={ArticlePage} />
                                        <Route path="/campaign/:slug" component={CampaignPage} />
                                        <Route
                                            path="/subscription-info"
                                            component={SubscriptionInfoPage}
                                        />
                                        <Route
                                            path="/delivery-info"
                                            component={CheckDeliveryPage}
                                        />
                                        <Route path="/gift-info" component={GiftPage} />
                                        <Route
                                            path="/3dsecure/paymentmethod"
                                            component={PaymentMethod3DSecureCallbackHandler}
                                        />

                                        <Route path="/bedrift" component={B2BPage} />

                                        <Route
                                            path={['/helg', '/hverdag', '/gave']}
                                            component={FocusPage}
                                        />

                                        <Route
                                            path="/:conceptPageIdentifier"
                                            component={ConceptPage}
                                        />

                                        <Route path="/" component={HomePage} />
                                    </Switch>
                                )}
                                <CartNotification />
                                <SubscriptionNotification />
                            </div>
                            {!hideFooter && <Footer hideFaq={isCheckout || isB2BPage} />}
                            <div className={bottomSpaceClasses} />
                        </PageTransition>
                        {isModal && <Route path="/product/:productId" component={ProductModal} />}
                        {isMobile && (
                            <BottomBar>
                                {!isB2BPage && <MobileBottomNotification />}
                                {showMobileBottomNavigation && <MobileBottomNavigation />}
                            </BottomBar>
                        )}
                        {(!isMobile || showMobileBottomNavigation) && <CustomerService />}
                        <CannotDeliverNotification />
                        <DistributionErrorNotification />
                        <DeliveryDateChangedNotification />
                    </div>
                </ConnectedRouter>
            </React.Fragment>
        )
    }
}

Router.propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    isMobile: PropTypes.bool.isRequired,
    region: PropTypes.string,
    isLoggedIn: PropTypes.bool,
    isNetworkError: PropTypes.bool,
    isCheckout: PropTypes.bool,
    isCart: PropTypes.bool,
    isDelivery: PropTypes.bool,
    isProduct: PropTypes.bool,
    isCategory: PropTypes.bool,
    isUSPPage: PropTypes.bool,
    isB2BPage: PropTypes.bool,
    subscriptionEnabled: PropTypes.bool,
    dispatch: PropTypes.func.isRequired,
    conceptPages: PropTypes.array,
    hasVisibleNotification: PropTypes.bool,
}

const mapStateToProps = (
    { router, ui, region, user, features, conceptPage, notification },
    { history }
) => {
    const location = router.location || history.location
    const isCheckout = new RegExp(/^\/checkout/).test(location.pathname)
    const isCart = RegExp(/^\/cart/).test(location.pathname)
    const isDelivery = RegExp(/^\/delivery$/).test(location.pathname)
    const isProduct = RegExp(/^\/product/).test(location.pathname)
    const isCategory = RegExp(/^\/categor/).test(location.pathname)
    const isUSPPage = !!(
        RegExp(/^\/subscription-info/).test(location.pathname) ||
        RegExp(/^\/delivery-info/).test(location.pathname) ||
        RegExp(/^\/gift-info/).test(location.pathname)
    )
    const isB2BPage = RegExp(/^\/bedrift\/.*/).test(location.pathname)
    const isNetworkError = ui.showNetworkErrorPage
    const isApp = ui.isApp

    return {
        location,
        isMobile: ui.isMobile,
        region: region.slug,
        isLoggedIn: user.isLoggedIn,
        isNetworkError,
        isCart,
        isCheckout,
        isDelivery,
        isProduct,
        isCategory,
        isUSPPage,
        isB2BPage,
        isApp,
        subscriptionEnabled: isFeatureEnabled(features, FEATURES.SUBSCRIPTION),
        conceptPages: conceptPage.conceptPages,
        hasVisibleNotification: notification.notifications.length > 0,
    }
}

export default connect(mapStateToProps)(Router)
